/* Anime l'ouverture/fermeture d'un <details>/<summary> avec
   grid-template-rows (component-accordion.css). Une transition CSS seule ne
   suffit pas : au moment où [open] change, le navigateur ne conserve pas de
   "frame d'avant" à partir de laquelle interpoler (le contenu d'un <details>
   fermé n'est pas rendu) — la hauteur passe directement de 0 à sa valeur
   finale. Ce script force ce frame d'avant (double requestAnimationFrame)
   avant de laisser la transition CSS tourner, et ne retire [open] qu'à la
   fin de la fermeture pour que le contenu reste visible pendant qu'il se
   réduit.

   Le regroupement par attribut "name" (un seul <details> ouvert à la fois)
   est natif tant qu'on laisse le navigateur gérer le toggle lui-même ; en
   interceptant le clic pour piloter l'animation, on le reproduit à la main
   via closeSiblings(). */
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(details) {
    if (details.dataset.accordionAnimated) return;
    details.dataset.accordionAnimated = 'true';

    var summary = details.querySelector(':scope > summary');
    var wrapper = details.querySelector(':scope > .accordion__content-wrapper');
    if (!summary || !wrapper) return;

    if (prefersReducedMotion) return;

    var animating = false;
    var closing = false;

    function closeSiblings() {
      var name = details.getAttribute('name');
      if (!name) return;
      document.querySelectorAll('details[name="' + CSS.escape(name) + '"]').forEach(function (other) {
        if (other !== details && other.open && other.accordionCollapse) {
          other.accordionCollapse();
        }
      });
    }

    function expand() {
      closeSiblings();
      animating = true;
      wrapper.style.transition = 'none';
      wrapper.style.gridTemplateRows = '0fr';
      wrapper.style.opacity = '0';
      // Force le navigateur à peindre cet état avant de basculer sur la
      // cible, sans quoi les deux changements arrivent dans le même frame.
      wrapper.getBoundingClientRect();
      details.open = true;
      requestAnimationFrame(function () {
        wrapper.style.transition = '';
        wrapper.style.gridTemplateRows = '1fr';
        wrapper.style.opacity = '1';
      });
    }

    function collapse() {
      closing = true;
      animating = true;
      wrapper.style.transition = 'none';
      wrapper.style.gridTemplateRows = '1fr';
      wrapper.style.opacity = '1';
      wrapper.getBoundingClientRect();
      requestAnimationFrame(function () {
        wrapper.style.transition = '';
        wrapper.style.gridTemplateRows = '0fr';
        wrapper.style.opacity = '0';
      });
    }
    details.accordionCollapse = collapse;

    wrapper.addEventListener('transitionend', function (event) {
      if (event.target !== wrapper || event.propertyName !== 'grid-template-rows') return;
      animating = false;
      wrapper.style.gridTemplateRows = '';
      wrapper.style.opacity = '';
      wrapper.style.transition = '';
      if (closing) {
        closing = false;
        details.open = false;
      }
    });

    summary.addEventListener('click', function (event) {
      event.preventDefault();
      if (animating) return;
      if (details.open) {
        collapse();
      } else {
        expand();
      }
    });
  }

  /* N'importe quel <details> avec un enfant .accordion__content-wrapper est
     concerné — pas seulement ceux marqués .accordion — setup() ignore
     silencieusement tout <details> qui n'a pas ce wrapper. */
  document.querySelectorAll('details').forEach(setup);
})();
